(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vk-private-tours"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!customElements.get('vkpt-hero-video')) {
    customElements.define('vkpt-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.video.muted = true;
        this.video.addEventListener('playing', () => this.toggleAttribute('data-playing', true), options);
        this.video.addEventListener('error', () => this.toggleAttribute('data-playing', false), options);
        this.motion.addEventListener('change', () => this.updatePlayback(), options);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting;
            this.updatePlayback();
          });
          this.observer.observe(this);
        } else { this.visible = true; this.updatePlayback(); }
      }
      updatePlayback() {
        if (this.motion.matches || navigator.connection?.saveData || !this.visible || document.hidden) {
          this.video.pause();
          this.toggleAttribute('data-playing', false);
          return;
        }
        if (!this.loaded) {
          this.video.querySelectorAll('source[data-src]').forEach((source) => { source.src = source.dataset.src; });
          this.video.load();
          this.loaded = true;
        }
        this.video.play()?.catch(() => this.toggleAttribute('data-playing', false));
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.video?.pause();
      }
    });
  }
  if (customElements.get('vk-private-tours')) return;

  class PrivateTours extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        this.form = this.querySelector('.vkpt-form');
        this.fields = Object.fromEntries(Array.from(this.querySelectorAll('[data-field]'), (field) => [field.dataset.field, field]));
        try { this.messages = JSON.parse(this.querySelector('[data-vkpt-messages]')?.textContent || '{}'); }
        catch { this.messages = {}; }
        this.catalogMessages = JSON.parse(this.querySelector('[data-vkpt-catalog-messages]')?.textContent || '{}');
        const options = { signal: this.controller.signal };
        this.addEventListener('click', (event) => this.onClick(event), options);
        this.addEventListener('keydown', (event) => this.onFilterKey(event), options);
        const filterBar = this.querySelector('[data-catalog-filters]');
        if (filterBar) { filterBar.hidden = false; this.filterTours('all'); }
        document.addEventListener('shopify:block:select', (event) => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          this.filterTours('all');
        }, options);
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('close', () => this.onClose(dialog), options);
          dialog.addEventListener('click', (event) => {
            const bounds = dialog.getBoundingClientRect();
            if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
          }, options);
        });
        if (!this.form) return;
        this.form.addEventListener('input', (event) => {
          if (event.target.setCustomValidity) event.target.setCustomValidity('');
          event.target.removeAttribute('aria-invalid');
          this.sync();
        }, options);
        this.form.addEventListener('change', () => this.sync(), options);
        this.form.addEventListener('submit', (event) => {
          if (!this.validate(false)) { event.preventDefault(); return; }
          this.prepareMessage();
        }, options);
        this.form.addEventListener('invalid', (event) => this.localizeInvalid(event.target), { ...options, capture: true });
        // Keep this field through Shopify validation redirects and page reloads.
        // Storage is scoped to this tab, locale and form; blocked storage is harmless.
        this.customizationStorageKey = `vkpt-customization:${location.pathname}:${this.form.id}`;
        try {
          if (this.querySelector('.vkpt-form-status')) {
            sessionStorage.removeItem(this.customizationStorageKey);
          } else {
            const saved = sessionStorage.getItem(this.customizationStorageKey);
            if (saved !== null) this.fields.special.value = saved;
          }
        } catch {}
        this.fields.special.addEventListener('input', () => this.saveCustomization(), options);
        this.querySelector('[data-message-summary]').disabled = false;
        this.querySelector('[data-tour-summary]').disabled = false;
        const whatsapp = this.querySelector('[data-whatsapp-button]');
        if (whatsapp) {
          whatsapp.hidden = false;
          this.querySelector('[data-whatsapp-note]').hidden = false;
        }
        this.restoreTourSelection();
        this.applyProductInquiry();
        this.sync();
        if ('IntersectionObserver' in window) {
          this.formObserver = new IntersectionObserver(([entry]) => {
            this.formVisible = entry.isIntersecting;
            this.updateSelectionBar();
          }, { threshold: 0 });
          this.formObserver.observe(this.form);
        }
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.inquiryFrame);
      if (this.activeDialog?.open) this.activeDialog.close();
      this.unlockScroll();
      this.formObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }

    onClick(event) {
      if (!(event.target instanceof Element)) return;
      const heart = event.target.closest('[data-toggle-tour]');
      if (heart && this.form) {
        event.preventDefault();
        event.stopPropagation();
        const option = this.form.querySelector(`input[data-tour-id="${CSS.escape(heart.dataset.toggleTour)}"]`);
        if (!option) return;
        this.selectTour(option, !option.checked);
        const message = option.checked ? this.catalogMessages.added : this.catalogMessages.selection_removed;
        this.querySelector('[data-catalog-selection-live]').textContent = (message || '').replace('{tour}', option.value);
        return;
      }
      const filter = event.target.closest('[data-filter-category]');
      if (filter) { this.filterTours(filter.dataset.filterCategory); return; }
      const inquiry = event.target.closest('[data-open-inquiry]');
      if (inquiry && this.form) {
        event.preventDefault();
        this.goToInquiry();
        return;
      }
      const back = event.target.closest('[data-back-to-catalog]');
      if (back) {
        const catalog = this.querySelector('.vkpt-destinations');
        if (!catalog) return;
        event.preventDefault();
        catalog.scrollIntoView({ behavior: this.reducedMotion() ? 'instant' : 'smooth', block: 'start' });
        this.querySelector('[data-filter-category][aria-pressed="true"]')?.focus({ preventScroll: true });
        return;
      }
      const trigger = event.target.closest('[data-open-tour]');
      if (trigger) {
        const dialog = this.querySelector(`#${CSS.escape(trigger.dataset.openTour)}`);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        this.opener = trigger;
        this.returnFocus = true;
        this.activeDialog = dialog;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
        dialog.querySelector('[data-close-tour]')?.focus();
        return;
      }
      const close = event.target.closest('[data-close-tour]');
      if (close) { close.closest('dialog')?.close(); return; }
      const remove = event.target.closest('[data-remove-tour]');
      if (remove && this.form) {
        const buttons = Array.from(this.querySelectorAll('[data-remove-tour]'));
        const index = buttons.indexOf(remove);
        const option = this.form.querySelector(`[data-tour-id="${CSS.escape(remove.dataset.removeTour)}"]`);
        if (!option) return;
        option.checked = false;
        this.sync();
        this.querySelector('[data-catalog-selection-live]').textContent = (this.catalogMessages.selection_removed || '').replace('{tour}', option.value);
        const remaining = Array.from(this.querySelectorAll('[data-remove-tour]'));
        (remaining[Math.min(index, remaining.length - 1)] || this.querySelector('[data-tour-picker] summary'))?.focus({ preventScroll: true });
        return;
      }
      const removeSelected = event.target.closest('[data-remove-selected-tour]');
      if (removeSelected && this.form) {
        const option = this.form.querySelector(`[data-tour-id="${CSS.escape(removeSelected.dataset.removeSelectedTour)}"]`);
        if (!option) return;
        option.checked = false;
        this.sync();
        this.returnFocus = true;
        removeSelected.closest('dialog')?.close();
        this.querySelector('[data-catalog-selection-live]').textContent = (this.catalogMessages.selection_removed || '').replace('{tour}', option.value);
        return;
      }
      const select = event.target.closest('[data-select-tour]');
      if (select && this.form) {
        const option = this.form.querySelector(`[data-tour-id="${CSS.escape(select.dataset.selectTour)}"]`);
        if (!option) return;
        this.selectTour(option);
        this.returnFocus = false;
        this.pendingInquiry = true;
        this.sync();
        this.querySelector('[data-tour-picker]').open = true;
        const dialog = select.closest('dialog');
        if (dialog?.open) dialog.close();
        else {
          this.pendingInquiry = false;
          this.unlockScroll();
          this.goToInquiry();
        }
        const message = this.catalogMessages.added || '';
        this.querySelector('[data-catalog-selection-live]').textContent = message.replace('{tour}', option.value);
        return;
      }
      if (event.target.closest('[data-whatsapp-button]')) this.openWhatsApp();
    }

    onClose(dialog) {
      if (this.activeDialog !== dialog) return;
      this.unlockScroll();
      this.activeDialog = null;
      if (this.pendingInquiry) {
        this.pendingInquiry = false;
        this.goToInquiry();
      } else if (this.returnFocus && this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }

    selectTour(option, selected = true) {
      option.checked = selected;
      this.sync();
    }

    restoreTourSelection() {
      this.selectionStorageKey = `vkpt-selected-tours:${this.dataset.sectionId}`;
      try {
        if (this.querySelector('.vkpt-form-status')) {
          sessionStorage.removeItem(this.selectionStorageKey);
          return;
        }
        const ids = JSON.parse(sessionStorage.getItem(this.selectionStorageKey) || '[]');
        if (!Array.isArray(ids)) return;
        this.form.querySelectorAll('input[data-tour-id]').forEach((option) => {
          if (ids.includes(option.dataset.tourId)) option.checked = true;
        });
      } catch {}
    }

    applyProductInquiry() {
      const params = new URLSearchParams(location.search);
      const id = params.get('private_tour');
      if (!id) return;
      const option = Array.from(this.form.querySelectorAll('input[data-tour-id]')).find((input) => input.dataset.tourId === id);
      if (option) this.selectTour(option);
      else {
        // Keep an unknown product as text; never substitute another checkbox.
        const title = params.get('private_tour_title') || id;
        const context = `${title} (ID: ${id})`;
        const field = this.fields.excursion;
        if (!field.value.includes(context)) field.value = [field.value, context].filter(Boolean).join(' · ');
        // Preserve the full context for submission, including unusually long titles.
        field.maxLength = Math.max(field.maxLength, field.value.length);
      }
      this.goToInquiry();
    }

    goToInquiry() {
      if (!this.form) return;
      const heading = this.form.querySelector('[data-tour-wishes-heading]');
      if (!heading) return;
      this.querySelector('[data-tour-picker]').open = true;
      // Wait for dialog focus restoration, scroll unlock and selection layout to settle.
      // A second request replaces a pending navigation instead of scrolling twice.
      cancelAnimationFrame(this.inquiryFrame);
      this.inquiryFrame = requestAnimationFrame(() => {
        this.inquiryFrame = requestAnimationFrame(() => {
          if (!this.isConnected || this.activeDialog?.open) return;
          heading.focus({ preventScroll: true });
          const headingTop = heading.getBoundingClientRect().top + window.scrollY;
          const header = document.getElementById('header-component');
          const stickyMode = header?.getAttribute('sticky');
          // Scroll-up headers disappear when moving down to the form.
          // Measure only the header that will cover the destination, not the
          // full header group (which can include non-sticky announcement bars).
          const willStick = stickyMode === 'always' || (stickyMode === 'scroll-up' && headingTop < window.scrollY);
          const headerHeight = willStick ? Math.max(0, header.getBoundingClientRect().height - 1) : 0;
          // Use document coordinates to avoid accumulating scroll-padding and
          // scroll-margin from the form or its ancestors. The legend is the target.
          window.scrollTo({ top: Math.max(0, headingTop - headerHeight), behavior: this.reducedMotion() ? 'instant' : 'smooth' });
        });
      });
    }

    unlockScroll() {
      if (this.previousOverflow !== undefined) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
    }

    filterTours(category) {
      const filterBar = this.querySelector('[data-catalog-filters]');
      if (!filterBar) return;
      const buttons = Array.from(filterBar.querySelectorAll('[data-filter-category]'));
      if (!buttons.some((button) => button.dataset.filterCategory === category)) category = 'all';
      buttons.forEach((button) => {
        const active = button.dataset.filterCategory === category;
        button.setAttribute('aria-pressed', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      let count = 0;
      this.querySelectorAll('[data-tour-category]').forEach((card) => {
        card.hidden = category !== 'all' && card.dataset.tourCategory !== category;
        if (!card.hidden) count += 1;
      });
      this.querySelector('[data-catalog-status]').textContent = filterBar.dataset.resultLabel.replace('{count}', String(count));
      this.querySelector('[data-catalog-empty]').hidden = count !== 0;
    }

    onFilterKey(event) {
      if (!(event.target instanceof Element) || !event.target.matches('[data-filter-category]')) return;
      const buttons = Array.from(this.querySelectorAll('[data-filter-category]'));
      let index = buttons.indexOf(event.target);
      if (event.key === 'ArrowRight') index = (index + 1) % buttons.length;
      else if (event.key === 'ArrowLeft') index = (index + buttons.length - 1) % buttons.length;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = buttons.length - 1;
      else return;
      event.preventDefault();
      buttons[index].focus();
      this.filterTours(buttons[index].dataset.filterCategory);
    }

    updateSelectionBar() {
      if (!this.form) return;
      const count = this.tours().length;
      const bar = this.querySelector('[data-selection-bar]');
      if (!bar) return;
      bar.hidden = count === 0 || Boolean(this.formVisible);
      this.toggleAttribute('data-has-selection', count > 0);
      this.querySelector('[data-bar-count]').textContent = (count === 1 ? this.catalogMessages.selected_one : this.catalogMessages.selected_many)?.replace('{count}', String(count)) || '';
    }

    reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    tours() { return Array.from(this.form.querySelectorAll('input[data-tour-id]:checked'), (input) => input.value); }
    label(field) {
      const label = this.form.querySelector(`label[for="${CSS.escape(field.id)}"]`)?.cloneNode(true);
      label?.querySelectorAll('[aria-hidden], .vkpt-optional, [hidden]').forEach((node) => node.remove());
      return label?.textContent.trim() || field.dataset.field;
    }

    sync() {
      if (this.selectionStorageKey) {
        try {
          const ids = Array.from(this.form.querySelectorAll('input[data-tour-id]:checked'), (input) => input.dataset.tourId);
          sessionStorage.setItem(this.selectionStorageKey, JSON.stringify(ids));
        } catch {}
      }
      const children = Number(this.fields.children.value) || 0;
      this.querySelector('[data-child-fields]').hidden = children <= 0;
      this.fields.ages.disabled = children <= 0;
      this.fields.ages.required = children > 0;
      const phoneRequired = this.fields.channel.value === 'whatsapp';
      this.fields.whatsapp_number.required = phoneRequired;
      this.querySelector('[data-phone-required]').hidden = !phoneRequired;
      this.querySelector('[data-phone-optional]').hidden = phoneRequired;
      this.fields.date.required = this.fields.flexibility.value !== 'undecided';
      this.querySelector('[data-date-required]').hidden = !this.fields.date.required;
      this.form.querySelector(`label[for="${CSS.escape(this.fields.date.id)}"] .vkpt-optional`).hidden = this.fields.date.required;
      const count = this.tours().length;
      this.querySelector('[data-selection-status]').textContent = (this.messages.selected_count || '').replace('{count}', String(count));
      this.querySelector('[data-tour-summary]').value = this.tours().join(' | ');
      this.querySelectorAll('[data-catalog-tour-id]').forEach((card) => {
        const option = this.form.querySelector(`[data-tour-id="${CSS.escape(card.dataset.catalogTourId)}"]`);
        const badge = card.querySelector('[data-card-selected]');
        badge.hidden = !option?.checked;
        const heart = card.querySelector('[data-toggle-tour]');
        if (heart && option) {
          heart.hidden = false;
          heart.setAttribute('aria-pressed', String(option.checked));
          const action = option.checked ? this.catalogMessages.remove_from_inquiry : this.catalogMessages.add_to_inquiry;
          heart.setAttribute('aria-label', `${action}: ${option.value}`);
        }
        const category = card.querySelector('.vkpt-tour__meta>span');
        card.querySelector('[data-open-tour]').setAttribute('aria-describedby', `${category.id}${option?.checked ? ` ${badge.id}` : ''}`);
      });
      this.querySelectorAll('[data-select-tour]').forEach((button) => {
        const option = this.form.querySelector(`[data-tour-id="${CSS.escape(button.dataset.selectTour)}"]`);
        button.querySelector('[data-selection-action]').textContent = this.catalogMessages.add_to_inquiry;
        button.closest('dialog').querySelector('[data-remove-selected-tour]').hidden = !option?.checked;
      });
      const selectedList = this.querySelector('[data-selected-tours]');
      selectedList.replaceChildren();
      this.form.querySelectorAll('input[data-tour-id]:checked').forEach((option) => {
        const item = document.createElement('li');
        const name = document.createElement('span');
        name.textContent = option.value;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.dataset.removeTour = option.dataset.tourId;
        remove.setAttribute('aria-label', `${this.catalogMessages.remove_from_inquiry}: ${option.value}`);
        remove.textContent = '×';
        item.append(name, remove);
        selectedList.append(item);
      });
      this.updateSelectionBar();
      // Changing a checkbox must also clear a previous selection error on the alternative text field.
      this.fields.excursion.setCustomValidity('');
      this.fields.ages.setCustomValidity('');
      this.fields.date.setCustomValidity('');
      this.fields.whatsapp_number.setCustomValidity('');
    }

    localizeInvalid(field) {
      if (!field.validity || field.validity.valid) return;
      field.setAttribute('aria-invalid', 'true');
      if (field.validity.customError) return;
      if (field.validity.valueMissing) field.setCustomValidity((this.messages.required_field || '').replace('{field}', this.label(field)));
      else if (field.validity.typeMismatch && field.type === 'email') field.setCustomValidity(this.messages.email_invalid || '');
      else if (field.validity.rangeUnderflow || field.validity.rangeOverflow || field.validity.stepMismatch || field.validity.badInput) field.setCustomValidity(this.messages.number_invalid || '');
    }

    validate(forWhatsApp) {
      this.sync();
      if (!this.fields.name.value.trim()) this.fields.name.setCustomValidity((this.messages.required_field || '').replace('{field}', this.label(this.fields.name)));
      if (!this.tours().length && !this.fields.excursion.value.trim()) this.fields.excursion.setCustomValidity(this.messages.tour_required);
      const phone = this.fields.whatsapp_number.value.trim();
      const normalized = phone.replace(/[\s().-]/g, '');
      if ((forWhatsApp || this.fields.channel.value === 'whatsapp' || phone) && !/^\+[1-9]\d{6,14}$/.test(normalized)) this.fields.whatsapp_number.setCustomValidity(this.messages.phone_invalid);
      const childCount = Number(this.fields.children.value) || 0;
      if (childCount > 0) {
        const ages = this.fields.ages.value.trim().split(/[,;\s]+/).filter(Boolean);
        if (ages.length !== childCount || ages.some((age) => !/^\d{1,2}$/.test(age))) this.fields.ages.setCustomValidity(this.messages.ages_required);
      }
      if (this.fields.flexibility.value !== 'undecided' && !this.fields.date.value) this.fields.date.setCustomValidity(this.messages.date_required);
      const valid = this.form.reportValidity();
      if (!valid) {
        const invalid = this.form.querySelector(':invalid');
        if (invalid) {
          let details = invalid.closest('details');
          if (details) details.open = true;
          invalid.focus();
        }
        this.querySelector('[data-form-live]').textContent = this.messages.form_error;
      }
      return valid;
    }

    message() {
      const line = (key) => {
        const field = this.fields[key];
        if (!field || field.disabled || !field.value.trim()) return null;
        const value = field instanceof HTMLSelectElement ? field.selectedOptions[0].textContent.trim() : field.value;
        return `${this.label(field)}: ${value}`;
      };
      const header = (key) => this.messages[key] || '';
      return [
        `Viva Karibik Tours — ${this.querySelector('h1').textContent.trim()}`,
        `${this.messages.navigation_language}: ${this.querySelector('[data-navigation-locale]').value}`, '', header('selected_tours'),
        ...this.tours().map((title) => `• ${title}`), line('excursion'), '', header('trip'),
        ...['date', 'flexibility', 'adults', 'children', 'ages', 'accommodation', 'language', 'special'].map(line),
        '', header('contact'), ...['name', 'email', 'whatsapp_number', 'channel'].map(line),
        '', this.messages.inquiry_note
      ].filter((part) => part !== null && part !== undefined).join('\n');
    }

    emailMessage() {
      const languages = { de: 'Deutsch', es: 'Spanisch', en: 'Englisch', fr: 'Französisch', nl: 'Niederländisch' };
      const labels = { excursion: 'Weiterer Ausflugswunsch', date: 'Wunschdatum', flexibility: 'Datumsflexibilität', adults: 'Erwachsene', children: 'Kinder', ages: 'Alter der Kinder', accommodation: 'Unterkunft oder Ausgangsort', language: 'Bevorzugte Guidesprache', special: 'Individuelle Wünsche / Touranpassungen', name: 'Name', email: 'E-Mail', whatsapp_number: 'WhatsApp mit internationaler Vorwahl', channel: 'Bevorzugter Antwortkanal' };
      const choices = { flexibility: { exact: 'Genau dieses Datum', flexible: 'Einige Tage flexibel', undecided: 'Datum noch offen' }, channel: { email: 'E-Mail', whatsapp: 'WhatsApp' } };
      const line = (key) => {
        const field = this.fields[key];
        if (!field || field.disabled || !field.value.trim()) return null;
        let value = field.value;
        if (key === 'language') value = `${languages[value] || value} (${value})`;
        else if (choices[key]) value = choices[key][value] || value;
        return `${labels[key]}: ${value}`;
      };
      const selected = Array.from(this.form.querySelectorAll('input[data-tour-id]:checked'));
      const navigation = this.querySelector('[data-navigation-locale]').value;
      return [
        'Viva Karibik Tours — Anfrage für private Ausflüge',
        `Navigationssprache: ${languages[this.lang] || this.lang} (${navigation})`,
        '', 'Ausgewählte Ausflüge',
        ...selected.map((input) => `• ${input.value}\n  Produkt-ID: ${input.dataset.tourId}\n  Produkt-Handle: ${input.dataset.tourHandle}\n  Referenz im Katalog: ${input.dataset.tourReference}\n  Produkt-URL: ${input.dataset.tourUrl}`),
        line('excursion'), '', 'Reise',
        ...['date', 'flexibility', 'adults', 'children', 'ages', 'accommodation', 'language', 'special'].map(line),
        '', 'Kontakt', ...['name', 'email', 'whatsapp_number', 'channel'].map(line),
        '', 'Dies ist eine Anfrage, keine bestätigte Buchung.'
      ].filter((part) => part !== null && part !== undefined).join('\n');
    }

    saveCustomization() {
      try { sessionStorage.setItem(this.customizationStorageKey, this.fields.special.value); }
      catch {}
    }

    prepareMessage() {
      this.saveCustomization();
      this.querySelector('[data-message-summary]').value = this.emailMessage();
      this.querySelector('[data-tour-summary]').value = this.tours().join(' | ');
    }

    openWhatsApp() {
      const button = this.querySelector('[data-whatsapp-button]');
      const destination = (button?.dataset.whatsappDestination || '').replace(/[\s+().-]/g, '');
      if (!/^[1-9]\d{6,14}$/.test(destination)) {
        this.querySelector('[data-form-live]').textContent = this.messages.whatsapp_missing;
        return;
      }
      if (!this.validate(true)) return;
      this.prepareMessage();
      const url = `https://wa.me/${destination}?text=${encodeURIComponent(this.message())}`;
      const windowRef = window.open(url, '_blank', 'noopener,noreferrer');
      if (windowRef) windowRef.opener = null;
      this.querySelector('[data-form-live]').textContent = this.messages.whatsapp_ready;
    }
  }
  customElements.define('vk-private-tours', PrivateTours);
})();


  } catch(e) { console.error(e); }
})();
})();
